export const translations = {
  ro: {
    'homepage:title': 'Asigurări online',
    'homepage:subtitle': 'Emitere instantă, format electronic',
    'homepage:green-card-title': 'Carte Verde',
    'homepage:green-card-subtitle': 'Pentru vehicule MD valabilă în afară',
    'homepage:rovignette-title': 'Rovinieta',
    'homepage:rovignette-subtitle': 'Taxa de vinietă în România',
    'homepage:rca-title': 'RCA',
    'homepage:rca-subtitle': 'Asigurare auto obligatorie',
    //
    'green-card-form:title': 'Carte Verde',
    'green-card-form:subtitle':
      'Asigurare carte verde, format digital. Polița o primiți automat după plată.',
    'green-card-form:region-label': 'Zona de deplasare',
    'green-card-form:region-ua': 'Ucraina',
    'green-card-form:region-eu': 'Toate țările „CarteVerde” (UE)',
    'green-card-form:insurance-period': 'Perioada asigurată',
    'green-card-form:start-date': 'Data începerii asigurării',
    'green-card-form:other-day': 'Altă zi ...',
    'green-card-form:certificate-number':
      'Număr/Serie certificat înmatriculare',
    'green-card-form:idnp-idno': 'Cod Personal IDNP/IDNO',
    'green-card-form:submit-button': 'Confirmă',
    'green-card-form:insurance-company': 'Compania de asigurare',
    'green-card-form:vehicle': 'Vehicul:',
    'green-card-form:insurance-period-summary': 'Perioada asigurată:',
    'green-card-form:region-summary': 'Zona de deplasare:',
    calculate: 'Calculează',
    'alert-unsaved-changes-title': 'Atenție!',
    'alert-unsaved-changes':
      'Aveți date nesalvate. Dacă continuați, modificările vor fi pierdute. Sigur doriți să continuați?',
    'offers-from': 'oferte (de la',
    'view-order': 'Vizualizează comanda',
    'green-card-with': 'Comanda Asigurare Carte Verde cu nr.',
    'green-card-was-created': 'a fost creată',
    today: 'Astăzi',
    tomorrow: 'Mâine',
    'day-after-tomorrow': 'Poimâine',
    'duration-15-days': '15 zile',
    'duration-1-month': '1 lună',
    'duration-2-months': '2 luni',
    'duration-3-months': '3 luni',
    'duration-4-months': '4 luni',
    'duration-5-months': '5 luni',
    'duration-6-months': '6 luni',
    'duration-7-months': '7 luni',
    'duration-8-months': '8 luni',
    'duration-9-months': '9 luni',
    'duration-10-months': '10 luni',
    'duration-11-months': '11 luni',
    'duration-12-months': '12 luni',
    'title-draft': 'Comanda dvs. a fost creată',
    'title-issued': 'Comanda dvs. a fost achitată',
    'title-processing': 'Comanda dvs. a fost achitată',
    'title-paid': 'Comanda dvs. a fost achitată',
    'title-completed': 'Asigurarea dvs. a fost emisă',
    'title-expired': 'Comanda dvs. a expirat',
    'title-failed': 'Comanda dvs. a eşuat',
    'title-refunded': 'Comanda dvs. a fost reîmbursată',
    'order-not-found:title': 'Comanda nu a fost găsită',
    'order-not-found:subtitle':
      'Dacă ai comandat deja, te rugăm să verifici confirmarea pe mail sau să ne contactezi.',
    'order-not-found:button': 'înapoi',
    'order:order-details-label': 'Detalii comanda',
    'order:order-type-label': 'Tipul asigurării:',
    'order:vehicle-label': 'Vehicul:',
    'order:duration-label': 'Durata:',
    'order:start-date': 'Data începerii:',
    'order:end-date': 'Data expirării:',
    'order:region-label': 'Regiunea:',
    'order:make-new': `Creează o comandă nouă`,
    'order:download-file': `Descarcă polița & contract`,
    'order:pay': 'Plătește',
    'offers-disclaimer':
      'Verificați detaliile comenzii, alegeți oferta de asigurare şi confirmați comanda. Comanda creată, cu link spre achitare va fi afișată in chat.',
    'snackbar:invalid-zone': 'Introduceți zona de deplasare',
    'snackbar:invalid-certificate':
      'Introduceți un certificat de înmatriculare valid',
    'snackbar:invalid-idnx': 'Introduceți un IDNP/IDNO valid',
    'snackbar:invalid-form-title': 'Verificați datele introduse',
    'snackbar:no-offers-found':
      'Nu au fost găsite oferte conform opțiunilor alese',
    'rovignette-form:title': 'Rovinietă',
    'rovignette-form:subtitle':
      'Pentru vehicule înmatriculate în Moldova, valabilă în România.',
    'rovignette:duration-label': 'Durata:',
    'rovignette-form:category': 'Categoria vehicul:',
    day: 'zi',
    days: 'zile',
    'rca-form:title': 'RCA',
    'rca-form:subtitle': 'Pentru vehicule înmatriculate în Moldova.',
  },
  ru: {
    'homepage:title': 'Онлайн страховки',
    'homepage:subtitle': 'Мгновенная выдача, электронный формат',
    'homepage:green-card-title': 'Зелёная карта',
    'homepage:green-card-subtitle':
      'Для автомобилей MD, действительная за границей',
    'homepage:rovignette-title': 'Ровиньетка',
    'homepage:rovignette-subtitle': 'Виньетка для Румынии',
    'homepage:rca-title': 'ОСАГО',
    'homepage:rca-subtitle': 'Обязательное автострахование',
    //
    'green-card-form:title': 'Онлайн страховки',
    'green-card-form:subtitle':
      'Страховка «Зелёная карта» в цифровом формате. Полис будет отправлен автоматически после оплаты.',
    'green-card-form:region-label': 'Зона страхования',
    'green-card-form:region-ua': 'Украина',
    'green-card-form:region-eu': 'Все страны "Зеленая Карта" (Европа)',
    'green-card-form:insurance-period': 'Период страховки',
    'green-card-form:start-date': 'Дата начала страховки',
    'green-card-form:other-day': 'Другой день ...',
    'green-card-form:certificate-number': 'Номер тех паспорта автомобиля',
    'green-card-form:idnp-idno': 'Идентификационный код IDNP/IDNO',
    'green-card-form:submit-button': 'Подтвердить',
    'green-card-form:insurance-company': 'Страховая компания',
    'green-card-form:vehicle': 'Транспортное средство:',
    'green-card-form:insurance-period-summary': 'Период страховки:',
    'green-card-form:region-summary': 'Зона страхования:',
    calculate: 'Рассчитать',
    'alert-unsaved-changes-title': 'Внимание!',
    'alert-unsaved-changes':
      'У вас есть несохраненные данные. Если вы продолжите, изменения будут утеряны. Вы уверены, что хотите продолжить?',
    'offers-from': 'предложения (от',
    'view-order': 'Просмотреть заказ',
    'green-card-with': 'Заказ на Зеленую карту с номером ',
    'green-card-was-created': 'был создан',
    today: 'Сегодня',
    tomorrow: 'Завтра',
    'day-after-tomorrow': 'Послезавтра',
    'duration-15-days': '15 дней',
    'duration-1-month': '1 месяц',
    'duration-2-months': '2 месяца',
    'duration-3-months': '3 месяца',
    'duration-4-months': '4 месяца',
    'duration-5-months': '5 месяцев',
    'duration-6-months': '6 месяцев',
    'duration-7-months': '7 месяцев',
    'duration-8-months': '8 месяцев',
    'duration-9-months': '9 месяцев',
    'duration-10-months': '10 месяцев',
    'duration-11-months': '11 месяцев',
    'duration-12-months': '12 месяцев',
    'title-draft': 'Ваш заказ был создан',
    'title-issued': 'Ваш заказ был оплачен',
    'title-processing': 'Ваш заказ был оплачен',
    'title-paid': 'Ваш заказ был оплачен',
    'title-completed': 'Ваш заказ был оформлен',
    'title-expired': 'Ваш заказ истёк',
    'title-failed': 'Ваш заказ не удался',
    'title-refunded': 'Ваш заказ был возмещён',
    'order-not-found:title': 'Заказ не найден',
    'order-not-found:subtitle':
      'Если вы уже оформили заказ, пожалуйста, проверьте подтверждение на почте или свяжитесь с нами.',
    'order-not-found:button': 'Назад',
    'order:order-details-label': 'Детали заказа',
    'order:order-type-label': 'Тип страховки:',
    'order:vehicle-label': 'Транспортное средство:',
    'order:duration-label': 'Длительность страховки:',
    'order:start-date': 'Дата старта:',
    'order:end-date': 'Дата завершения:',
    'order:region-label': 'Зона страхования:',
    'order:make-new': 'Создать новый заказ',
    'order:download-file': 'Скачать полис & договор',
    'order:pay': 'Оплатить',
    'offers-disclaimer':
      'Проверьте детали заказа, выберите предложение страхования и подтвердите заказ. Созданный заказ с ссылкой для оплаты будет отображен в чате.',
    'snackbar:invalid-zone': 'Введите зону страхования',
    'snackbar:invalid-certificate': 'Введите действительный номер тех паспорта',
    'snackbar:invalid-idnx': 'Введите действительный IDNP/IDNO',
    'snackbar:invalid-form-title': 'Проверьте введенные данные',
    'snackbar:no-offers-found':
      'Не найдено предложений по выбранным параметрам',
    'rovignette-form:title': 'Ровиньетка',
    'rovignette-form:subtitle':
      'Для транспортных средств зарегистрированных в Молдове, действует в Румынии.',
    'rovignette:duration-label': 'Длительность ровиньетки:',
    'rovignette-form:category': 'Категория транспорта:',
    day: 'день',
    days: 'дней',
    'rca-form:title': 'ОСАГО',
    'rca-form:subtitle':
      'Для транспортных средств, зарегистрированных в Молдове.',
  },
};
